import React, { type JSX, Suspense, lazy } from 'react'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { state$ as userAccountState$ } from '@core/State/UserAccount/userAccountDriver'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { useObservableProperties } from '@core/Utils/hooks'

const App = lazy(() => import('@mobi/account/Areas/ContactDetails/Components/App'))

export const ContactDetails = (): JSX.Element | null => {
  const { accountNumber } = useObservableProperties(userAccountState$, ['accountNumber'], {
    accountNumber: null,
  })

  // This page cannot be loaded if the user isn't logged in anyway
  if (accountNumber === null) return <Spinner />

  return (
    <Suspense fallback={<Spinner />}>
      <App betAccountNumber={accountNumber} appVersion={fullClientVersion} />
    </Suspense>
  )
}
